export class GetPlayFields {
  static readonly type = '[playFields] Get PlayFields';
  constructor() {}
}
